<template>
  <!--
    nevo group Logo liegt nur als Rasterbild vor.
    Datei ablegen unter: apps/portal/public/partners/nevo-group.png
    (Das Logo ist für dunklen Hintergrund gedacht – "group" ist weiß.)
  -->
  <img src="/partners/main-logo-min.webp" alt="nevo group" />
</template>
